module.exports = __webpack_public_path__ + "static/hero4-92ebfa0ce9ceb8d031414b75e8674873.jpg";